<template>
  <div id="app">
    <div>
      <router-view/>
      <!-- set progressbar -->
      <vue-progress-bar></vue-progress-bar>
    </div>
  </div>
</template>

<script>
export default {
  name: "App",
  metaInfo() {
    return {
      // if no subcomponents specify a metaInfo.title, this title will be used
      title: "Tapapp",
      // all titles will be injected into this template
    	titleTemplate: '%s',
  	}
	}
};
</script>

<style lang="scss">
@import "./assets/css/bootstrap.min.css";
@import "./assets/css/font-awesome.min.css";
@import "./assets/css/sidebar.css";
@import "./assets/css/scss/components.scss";
@import "./assets/css/scss/style.scss";
@import "~vue-awesome-notifications/dist/styles/style.scss";
@import "bootstrap-vue/dist/bootstrap-vue.css";
@import "vue-multiselect/dist/vue-multiselect.min.css";
</style>



// WEBPACK FOOTER //
// src/App.vue